import { withTheme } from 'styled-components';
import FareAddOnLeg from './FareAddOnLeg';

export default withTheme(FareAddOnLeg);
